import pushClevertapEvent from '../pushClevertapEvent';

export function onClickNextButton(email) {
  pushClevertapEvent('onClick welcome modal', {
    Email: email,
  });
}

export function onUpdateBusinessRevenue(email) {
  pushClevertapEvent('onUpdate Business Revenue', {
    Email: email,
  });
}

export function onUpdateBusinessStartYear(email) {
  pushClevertapEvent('onUpdate Business Start Year', {
    Email: email,
  });
}

export function onClickStartSelling(email) {
  pushClevertapEvent('onClick Start Selling', {
    Email: email,
  });
}
